import * as ambassadorWixMultilingualGenericconverterV1EntityMapper from './multilingual-genericconverter-v1-entity-mapper-entity-mapper.http.js';
import * as ambassadorWixMultilingualGenericconverterV1EntityMapperTypes from './multilingual-genericconverter-v1-entity-mapper-entity-mapper.types.js';
import * as ambassadorWixMultilingualGenericconverterV1EntityMapperUniversalTypes from './multilingual-genericconverter-v1-entity-mapper-entity-mapper.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function syncEditorData(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixMultilingualGenericconverterV1EntityMapperUniversalTypes.SyncEditorDataRequest,
  ambassadorWixMultilingualGenericconverterV1EntityMapperTypes.SyncEditorDataRequest,
  ambassadorWixMultilingualGenericconverterV1EntityMapperUniversalTypes.SyncEditorDataResponse,
  ambassadorWixMultilingualGenericconverterV1EntityMapperTypes.SyncEditorDataResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMultilingualGenericconverterV1EntityMapper.syncEditorData(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/pull_data',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Mapper as MapperOriginal,
  MapperField as MapperFieldOriginal,
  FieldType as FieldTypeOriginal,
  FieldTypeWithLiterals as FieldTypeWithLiteralsOriginal,
  SequencePath as SequencePathOriginal,
  Empty as EmptyOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  CreateOrUpdateNileMapperRequest as CreateOrUpdateNileMapperRequestOriginal,
  CreateOrUpdateNileMapperResponse as CreateOrUpdateNileMapperResponseOriginal,
  GetEntityMapperRequest as GetEntityMapperRequestOriginal,
  GetEntityMapperResponse as GetEntityMapperResponseOriginal,
  ListEntityMapperRequest as ListEntityMapperRequestOriginal,
  ListEntityMapperResponse as ListEntityMapperResponseOriginal,
  DeleteEntityMapperRequest as DeleteEntityMapperRequestOriginal,
  DeleteEntityMapperResponse as DeleteEntityMapperResponseOriginal,
  GetSubscribedTopicsRequest as GetSubscribedTopicsRequestOriginal,
  GetSubscribedTopicsResponse as GetSubscribedTopicsResponseOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  HtmlNewRevisionSavedMessage as HtmlNewRevisionSavedMessageOriginal,
  RevisionInfo as RevisionInfoOriginal,
  Page as PageOriginal,
  ChangedPages as ChangedPagesOriginal,
  SyncEditorDataRequest as SyncEditorDataRequestOriginal,
  SyncFilter as SyncFilterOriginal,
  SyncEditorDataResponse as SyncEditorDataResponseOriginal,
  PublishSiteTranslationsRequest as PublishSiteTranslationsRequestOriginal,
  PublishSiteTranslationsResponse as PublishSiteTranslationsResponseOriginal,
  CreateOrUpdateEditorMapperRequest as CreateOrUpdateEditorMapperRequestOriginal,
  CreateOrUpdateEditorMapperResponse as CreateOrUpdateEditorMapperResponseOriginal,
  GetMapperRequest as GetMapperRequestOriginal,
  GetMapperResponse as GetMapperResponseOriginal,
  DeleteMapperRequest as DeleteMapperRequestOriginal,
  DeleteMapperResponse as DeleteMapperResponseOriginal,
  ListMappersRequest as ListMappersRequestOriginal,
  ListMappersResponse as ListMappersResponseOriginal,
} from './multilingual-genericconverter-v1-entity-mapper-entity-mapper.types.js';
